import React from 'react'
import { CirclePlay } from 'lucide-react'

const icon = props => <CirclePlay size={20} {...props} />

export default icon
